import React, { CSSProperties } from 'react';
import styles from './HorizontalDivider.module.scss';

interface HorizontalDividerProps {
  top?: number;
  bottom?: number;
  style?: CSSProperties;
  [key: string]: any;
}

const HorizontalDivider: React.FC<HorizontalDividerProps> = ({
  top = 5,
  bottom = 5,
  style,
  ...props
}) => {
  const _style = {
    paddingTop: `${top}px`,
    marginBottom: `${bottom}px`,
    ...style
  };
  return <div className={styles.wrapper} style={_style} {...props} />;
};

export default HorizontalDivider;
